module.exports = __webpack_public_path__ + "img/logo.8cab7813.png";